import { createSelector } from 'reselect';

export const getImportsData = createSelector(state => state.DataImports, u =>u);